import { useSyncExternalStore } from "react";

// The visitor's reduced-motion preference, which can change while the page is
// open (a system setting, a browser's accessibility switch).

const REDUCED_MOTION = "(prefers-reduced-motion: reduce)";

/** The preference at this moment. */
export function prefersReducedMotion(): boolean {
  return window.matchMedia(REDUCED_MOTION).matches;
}

function subscribe(onChange: () => void): () => void {
  const query = window.matchMedia(REDUCED_MOTION);
  query.addEventListener("change", onChange);
  return () => query.removeEventListener("change", onChange);
}

const unknownOnServer = () => false;

/**
 * The preference as render state, so an effect that depends on it runs again
 * when it changes. It is false on the server and during hydration, so such an
 * effect reads prefersReducedMotion() itself: a reduced-motion visitor never
 * sees motion start for one frame after hydration.
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, prefersReducedMotion, unknownOnServer);
}
